import { makeStyles } from '@material-ui/core/styles';
import { SOURCES }  from '../../../../../constants/sources';

export default makeStyles((theme) => ({
    rootBase: {
        width: '328px',
        minHeight: '158px',
        maxHeight: '536px',
    }, 
    bodyContainer: {
        width: '100%',
        maxHeight: '536px',
        borderRadius: '8px',
    },
}));